const openZendeskChat = () => {
    window.$zopim.livechat.window.show();
};

export { openZendeskChat };
